import { useModal } from '@shared/model/useModal';

export const useRemoveHomeworkModal = () => useModal('remove-homework')